import { environment } from './environment/environment';

export const apiBaseUrl = environment.apiBaseUrl;
export const versionInfo = environment.versionInfo;
export const isProdMode = environment.production;
export const apiRoots = {};
export const googleMapsApiKey = environment.googleApiKey;
